import type { EChartsOption } from 'echarts';

/** BrandDetail 风险雷达的单维 risk formula component（后端 /brands/{id}/weekly 暴露）。 */
export interface RiskComponent {
  key: string;
  label: string;
  value: number;
  weight: number;
}

/**
 * 用后端真实 risk_components 构造风险雷达 option。
 *
 * 替代 9.2a 的占位反推（buildRiskRadar）：indicator 名称、6 维取值、顺序
 * 全部由 API 提供，前端不再自算 / 不再标"示意"。
 */
export function buildBrandRiskRadar(components: RiskComponent[]): EChartsOption {
  return {
    tooltip: {},
    radar: {
      indicator: components.map((c) => ({ name: c.label, max: 100 })),
      shape: 'polygon',
      splitArea: { show: false },
      axisLabel: { color: '#64748B', fontSize: 10 },
      axisName: { color: '#475569', fontSize: 11 },
    },
    series: [
      {
        type: 'radar',
        data: [
          {
            value: components.map((c) => c.value),
            name: '本周',
            itemStyle: { color: '#EA580C' },
            areaStyle: { color: '#EA580C', opacity: 0.2 },
          },
        ],
      },
    ],
  };
}
